var map = {
	"./coingecko.png": "f8a6",
	"./coinmarketcap.png": "f5be",
	"./discord.png": "ff88",
	"./element.png": "b366",
	"./email.png": "1fd3",
	"./github.png": "e27c",
	"./job.png": "b37d",
	"./medium.png": "1009",
	"./subsocial.png": "62cd",
	"./telegram.png": "3e16",
	"./twitter.png": "c3be",
	"./website.png": "02e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "28d2";